import { SHOW_USER_PREFERENCES_MODAL, HIDE_USER_PREFERENCES_MODAL } from './userPreferencesActionTypes'

export const showUserPreferences = () => ({
    type: SHOW_USER_PREFERENCES_MODAL,
});

export const hideUserPreferences = () => ({
    type: HIDE_USER_PREFERENCES_MODAL
})
